/* List Collections V2 — client-side search, filter chips, sort, view toggle.
   One IIFE per section root so multiple instances on a page don't collide. */
(function () {
  function init(root) {
    if (root.dataset.collistInit === '1') return;
    root.dataset.collistInit = '1';

    var grid           = root.querySelector('[data-collist-grid]');
    var items          = grid ? Array.from(grid.querySelectorAll('[data-collist-item]')) : [];
    var searchInput    = root.querySelector('[data-collist-search]');
    var sortSelect     = root.querySelector('[data-collist-sort]');
    var visibleCounter = root.querySelector('[data-collist-visible]');
    var emptyState     = root.querySelector('[data-collist-empty]');
    var resetBtns      = Array.from(root.querySelectorAll('[data-collist-reset]'));
    var groups         = Array.from(root.querySelectorAll('[data-filter-group]'));
    var viewBtns       = Array.from(root.querySelectorAll('[data-mti-v2-view-btn]'));

    // Persist view choice across visits
    var VIEW_KEY = 'mti-v2-collist-view';
    function applyView(view) {
      root.setAttribute('data-view', view);
      viewBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.mtiV2ViewBtn === view ? 'true' : 'false');
      });
    }
    var storedView = null;
    try { storedView = localStorage.getItem(VIEW_KEY); } catch (e) {}
    applyView(storedView === 'list' ? 'list' : 'grid');
    viewBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.dataset.mtiV2ViewBtn;
        try { localStorage.setItem(VIEW_KEY, v); } catch (e) {}
        applyView(v);
      });
    });

    // Active filter values per group { groupKey: Set<string> }
    var activeFilters = {};
    groups.forEach(function (g) { activeFilters[g.dataset.filterGroup] = new Set(); });

    var searchTerm = '';
    var sortMode = 'manual';
    var originalOrder = items.slice();

    function itemMatches(li) {
      // Search by title (case-insensitive substring)
      if (searchTerm) {
        var title = li.dataset.title || '';
        if (title.indexOf(searchTerm) === -1) return false;
      }
      // Each filter group: match-any within group, match-all across groups
      for (var key in activeFilters) {
        var active = activeFilters[key];
        if (active.size === 0) continue;
        var raw = (li.dataset['filter' + key.charAt(0).toUpperCase() + key.slice(1).replace(/[-_](.)/g, function (_, c) { return c.toUpperCase(); })] || '');
        // Fallback: also try kebab-case data attribute lookup
        if (!raw) raw = li.getAttribute('data-filter-' + key) || '';
        var values = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        var any = false;
        active.forEach(function (v) { if (values.indexOf(v) !== -1) any = true; });
        if (!any) return false;
      }
      return true;
    }

    function applyFilters() {
      var visible = 0;
      items.forEach(function (li) {
        var match = itemMatches(li);
        if (match) {
          li.hidden = false;
          visible++;
        } else {
          li.hidden = true;
        }
      });
      if (visibleCounter) visibleCounter.textContent = visible;
      if (emptyState) emptyState.hidden = visible !== 0;
      var anyFilterActive = !!searchTerm || Object.keys(activeFilters).some(function (k) { return activeFilters[k].size > 0; });
      resetBtns.forEach(function (b) { b.hidden = !anyFilterActive; });
    }

    function applySort() {
      if (!grid) return;
      var sorted = items.slice();
      if (sortMode === 'title-asc') {
        sorted.sort(function (a, b) { return (a.dataset.title || '').localeCompare(b.dataset.title || ''); });
      } else if (sortMode === 'title-desc') {
        sorted.sort(function (a, b) { return (b.dataset.title || '').localeCompare(a.dataset.title || ''); });
      } else if (sortMode === 'count-desc') {
        sorted.sort(function (a, b) { return (+b.dataset.count || 0) - (+a.dataset.count || 0); });
      } else if (sortMode === 'count-asc') {
        sorted.sort(function (a, b) { return (+a.dataset.count || 0) - (+b.dataset.count || 0); });
      } else {
        sorted = originalOrder.slice();
      }
      var frag = document.createDocumentFragment();
      sorted.forEach(function (li) { frag.appendChild(li); });
      grid.appendChild(frag);
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        searchTerm = (searchInput.value || '').trim().toLowerCase();
        applyFilters();
      });
    }

    groups.forEach(function (group) {
      var key = group.dataset.filterGroup;
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.mti-v2-collist__chip');
        if (!btn || !group.contains(btn)) return;
        var val = btn.dataset.filterValue;
        if (!val) return;
        var set = activeFilters[key];
        if (set.has(val)) {
          set.delete(val);
          btn.setAttribute('aria-pressed', 'false');
        } else {
          set.add(val);
          btn.setAttribute('aria-pressed', 'true');
        }
        applyFilters();
      });
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        sortMode = sortSelect.value;
        applySort();
      });
    }

    resetBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        searchTerm = '';
        if (searchInput) searchInput.value = '';
        Object.keys(activeFilters).forEach(function (k) { activeFilters[k].clear(); });
        root.querySelectorAll('.mti-v2-collist__chip[aria-pressed="true"]').forEach(function (c) {
          c.setAttribute('aria-pressed', 'false');
        });
        applyFilters();
      });
    });

    applyFilters();
  }

  function boot() {
    document.querySelectorAll('[data-mti-v2-collist]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
